import React, { Component } from "react";
import { Container, Col, Row } from "react-bootstrap";

export default class VistaPersonaContactoHermana extends Component {
  render() {
    let VistaPersonaContacto =
      this.props.DatosMonja.sister && this.props.DatosMonja.sister.contactName ? (
        <Container>
          <Row>
            <Col lg="3" className="border">
              <h6>Nombre</h6>
              <p>{this.props.DatosMonja.sister.contactName}</p>
            </Col>

            <Col lg="3" className="border">
              <h6>Apellidos</h6>
              <p>{this.props.DatosMonja.sister.contactSurname}</p>
            </Col>

            <Col lg="3" className="border">
              <h6>Parentesco</h6>
              <p>{this.props.DatosMonja.sister.contactRelationship}</p>
            </Col>

            <Col lg="3" className="border">
              <h6>País</h6>
              <p>{this.props.DatosMonja.sister.contactCountry}</p>
            </Col>
          </Row>
          <Row>
            <Col lg="3" className="border">
              <h6>Provincia</h6>
              <p>{this.props.DatosMonja.sister.contactProvince}</p>
            </Col>
            <Col lg="3" className="border">
              <h6>Dirección</h6>
              <p>{this.props.DatosMonja.sister.contactAddress}</p>
            </Col>
            <Col lg="3" className="border">
              <h6>Teléfono</h6>
              <p>{this.props.DatosMonja.sister.contactTelephone}</p>
            </Col>
            <Col lg="3" className="border">
              <h6>Email</h6>
              <p>{this.props.DatosMonja.sister.contactEmail}</p>
            </Col>
          </Row>
        </Container>
      ) : (
        <p className="ml-3">No hay datos actualmente</p>
      );
    return <React.Fragment>{VistaPersonaContacto}</React.Fragment>;
  }
}
